<script lang="ts">
	import FormatText from '../formatText/FormatText.svelte'
	import Icon from '../icon/Icon.svelte'
	import { replaceVariables } from '../replaceVariables/replaceVariables'
	import StructuredText from '../structuredText/StructuredText.svelte'
	import { isStructuredTextEmpty } from '../structuredText/structuredText'
	import Tooltip from '../tooltip/Tooltip.svelte'
	import { InformationCircle } from '@steeze-ui/heroicons'
	import type { HelpRecord } from 'datocms/models'

	interface Props {
		item: HelpRecord
		variables?: Record<string, string>
	}

	let { item, variables = {} }: Props = $props()

	let isTooltip = $derived(item.helpTooltipText && !isStructuredTextEmpty(item.helpTooltipText))
</script>

<div class="group relative">
	<span class="inline-flex items-center gap-2">
		<span>
			<FormatText text={replaceVariables(item.helpText, variables)} />
		</span>

		{#if isTooltip}
			<div class="inline-flex h-4 w-4">
				<Tooltip>
					{#snippet placeholder()}
						<Icon outline small src={InformationCircle} />
					{/snippet}
					<StructuredText structuredText={item.helpTooltipText.value} />
				</Tooltip>
			</div>
		{/if}
	</span>
</div>
